module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9KD05"))).then(() => module.bundle.root('f4eak'));